<template>
  <div class="tree-node">
    <div class="tree-node-row">
      <button
        v-if="hasChildren"
        type="button"
        class="tree-toggle"
        :aria-expanded="!!node.opened"
        @click.stop="onTreeToggle(node)"
      >
        <i
          class="fa-solid"
          :class="node.opened ? 'fa-chevron-down' : 'fa-chevron-right'"
        ></i>
      </button>
      <span v-else class="tree-toggle-spacer" aria-hidden="true"></span>
      <slot :node="node" :path="path"></slot>
    </div>
    <div v-if="node.opened && hasChildren" class="tree-children">
      <tree-node
        v-for="(child, i) in node.children"
        :key="child.id ?? i"
        :node="child"
        :path="[...path, i]"
      >
        <template #default="slotProps">
          <slot v-bind="slotProps"></slot>
        </template>
      </tree-node>
    </div>
  </div>
</template>

<script>
export default {
  name: "TreeNode",
  props: {
    node: { type: Object, required: true },
    path: { type: Array, default: () => [] }
  },
  inject: ["onTreeToggle"],
  computed: {
    hasChildren() {
      return Array.isArray(this.node.children) && this.node.children.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.tree-node-row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.tree-toggle,
.tree-toggle-spacer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.tree-toggle {
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  color: inherit;
  font-size: 0.75rem;

  &:hover i {
    opacity: 0.75;
  }
}

.tree-children {
  padding-left: 1.25rem;
}
</style>
